// stores
import * as ConceptValueStore from '../../../../redux/middleware/ProtocolConsumptionConceptValues.Middleware';

// state
import { AppState } from '../../../../redux/reducers';
import { Protocol } from '../../../../models/Entities/Protocols/Protocol';
import { ProtocolConsumption } from '../../../../models/Entities/Protocols/ProtocolConsumption';
import { ProtocolConsumptionConceptValues } from '../../../../models/Entities/Protocols/ProtocolConsumptionConceptValues';
import { ErrorType } from '../../../../models/HttpError';

//#region Props

interface IProps {
    ProtocolId: number;
    ProtocolConsumptionId: string;
    /** La fila a borrar; undefined mantiene el dialogo cerrado. */
    ConceptValue: ProtocolConsumptionConceptValues | undefined;
    isOpen: boolean;
    onClose: () => void;
}

interface ConnectedProps {
    Consumption: ProtocolConsumption | null;
    /** Se lee del store y no del prop: el prop es la copia del momento de abrir. */
    isDeleting: boolean;
    failOnDeleting: boolean;
    errorOnDeleting: ErrorType | undefined;
    /** Deja de existir en el store una vez que el borrado termino bien. */
    stillExists: boolean;
}

interface DispatchProps {
    DeleteConceptValue: typeof ConceptValueStore.ActionCreators.DeleteConceptValue;
}

export type Props = IProps & ConnectedProps & DispatchProps;

//#endregion Props

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const auxProtocol: Protocol | null =
        state.MedicalProtocols?.list?.find((protocol: Protocol) => protocol.id === ownProps.ProtocolId) || null;

    const auxConsumption: ProtocolConsumption | null =
        auxProtocol?.consumptions?.find(
            (consumption: ProtocolConsumption) => consumption.id === ownProps.ProtocolConsumptionId
        ) ??
        auxProtocol?.consumptions?.flatMap(
            (consumption: ProtocolConsumption) => consumption.childConsumption ?? []
        ).find(
            (consumption: ProtocolConsumption) => consumption.id === ownProps.ProtocolConsumptionId
        ) ?? null;

    const auxConceptValue: ProtocolConsumptionConceptValues | undefined = ownProps.ConceptValue
        ? auxConsumption?.conceptValues?.find(
            (value: ProtocolConsumptionConceptValues) => value.id === ownProps.ConceptValue?.id
        )
        : undefined;

    return {
        Consumption: auxConsumption,
        isDeleting: auxConceptValue?.isDeleting ?? false,
        failOnDeleting: auxConceptValue?.failOnDeleting ?? false,
        errorOnDeleting: auxConceptValue?.ErrorOnDeleting,
        stillExists: auxConceptValue !== undefined
    };
};

export const mapDispatchToProps = {
    ...ConceptValueStore.ActionCreators
};
